<template>
  <ul class="steps-list">
    <li
      v-for="(stage, index) in applicationStages"
      :key="stage.stage_name"
      class="step"
      data-cy="step"
    >
      <div class="relative flex flex-col items-center space-y-1">
        <div
          class="step-circle mt-0.5"
          :class="{
            'bg-white': index === indexOfCurrentStage && !isDeclined,
            'bg-branding-progress-bar': index < indexOfCurrentStage && !isDeclined,
            'bg-red-400': index <= indexOfCurrentStage && isDeclined,
            'bg-transparent': index > indexOfCurrentStage,
          }"
        >
          <icon-checkmark v-if="index < indexOfCurrentStage" class="text-white" />
          <icon-x v-else-if="index === indexOfCurrentStage && isDeclined" class="text-white" />
          <div
            v-else
            class="inner-circle"
            :class="index === indexOfCurrentStage ? 'bg-branding-progress-bar' : 'bg-gray-300'"
          />
        </div>
        <div
          class="stage-info"
          :class="{ 'left-0': !index, 'right-2': index === applicationStages.length - 1 }"
        >
          <div
            class="flex items-center space-x-1.5"
            :class="index === indexOfCurrentStage ? 'text-white' : 'text-white opacity-30'"
          >
            <span class="text-xs font-medium lg:text-sm" data-cy="stage-name">
              {{ stage.stage_name }}
            </span>
            <div>
              <icon-info
                v-tooltip="{ content: stage.stage_description, placement: 'bottom' }"
                class="cursor-pointer"
                data-cy="icon-info"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="index !== applicationStages.length - 1"
        class="step-line"
        :class="{
          'bg-branding-progress-bar': index < indexOfCurrentStage && !isDeclined,
          'bg-red-400': index < indexOfCurrentStage && isDeclined,
          'bg-white opacity-30': index >= indexOfCurrentStage,
        }"
      />
    </li>
  </ul>
</template>

<script setup lang="ts">
import { computed } from "vue";
import IconX from "@/components/icons/IconX.vue";
import IconCheckmark from "@/components/icons/IconCheckmark.vue";
import IconInfo from "@/components/icons/IconInfo.vue";
import useApplicationsState from "@/composables/state/applicationsState";

const { applicationStages, isDeclined } = useApplicationsState();

const indexOfCurrentStage = computed(() => {
  return applicationStages.value.findIndex((stage) => stage.is_current);
});
</script>

<style scoped>
@reference "@/tailwind.css";

.steps-list {
  @apply flex list-none lg:pt-0;
}

.step {
  @apply relative flex h-16 max-w-full grow items-center;
}

.step-circle {
  @apply relative top-0.5 -ml-2 flex h-4 w-4 items-center justify-center rounded-full;
  z-index: 1;
}

.step-line {
  @apply absolute top-1/2 left-0 h-0.5 w-full;
}

.inner-circle {
  @apply h-2 w-2 rounded-full;
}

.step:last-child {
  @apply max-w-0;
}
.stage-info {
  @apply absolute my-6 inline-block whitespace-nowrap;
}

.step:nth-child(odd) .stage-info {
  @apply top-2;
}

.step:nth-child(even) .stage-info {
  @apply -top-11 lg:top-2;
}
</style>
